//@ts-nocheck
// src/parquetLoader.ts
import { tableFromIPC } from 'apache-arrow';
import ParquetWorker from './parquetWorker.js?worker';

export async function getParquetFilesAsArrow(
  companyFiles: string[],
  onLoading?: (isLoading: boolean, progress?: number, total?: number) => void
): Promise<Record<string, arrow.Table>> {
  if (!Array.isArray(companyFiles) || companyFiles.length === 0) {
    console.error('Error: companyFiles is invalid or empty');
    return {};
  }

  const filePaths = companyFiles.map(file =>
    file.startsWith('/data/') ? file : `/data/${file}`
  );

  //console.log('Starting getParquetFilesAsArrow with filePaths:', filePaths);

  return new Promise((resolve, reject) => {
    //console.log('Creating ParquetWorker');
    const worker = new Worker(new URL('./parquetWorker.js', import.meta.url), { type: 'module' });

    worker.onmessage = (e) => {
      //console.log('Received worker message:', e.data);
      if (e.data.type === 'loading') {
        onLoading?.(e.data.isLoading, e.data.progress, e.data.total);
      } else if (e.data.type === 'success') {
        setTimeout(() => {
          try {
            const tablesObj: Record<string, arrow.Table> = {};
            for (const tableData of e.data.tables) {
              const { buffer, tableName } = tableData;
              if (!tableName || !buffer) {
                console.warn('Missing tableName or buffer in tableData:', tableData);
                continue;
              }
              tablesObj[tableName] = tableFromIPC(buffer);
            }
            //console.log('Resolved tables object:', Object.keys(tablesObj));
            onLoading?.(false, e.data.progress, e.data.total);
            resolve(tablesObj);
            worker.terminate(); // Clean up worker
          } catch (error) {
            console.error('Error deserializing tables:', error);
            onLoading?.(false, 0, e.data.total || filePaths.length);
            reject(error);
            worker.terminate();
          }
        }, 0);
      } else if (e.data.type === 'log') {
        //console.log(...e.data.message);
      } else if (e.data.type === 'error') {
        console.error('Worker error:', e.data.error);
        onLoading?.(false, 0, e.data.total || filePaths.length);
        reject(new Error(e.data.error));
        worker.terminate();
      }
    };

    worker.onerror = (error) => {
      console.error('Worker initialization or runtime error:', error);
      onLoading?.(false, 0, filePaths.length);
      reject(error);
      worker.terminate();
    };

    worker.onmessageerror = (error) => {
      console.error('Worker message error:', error);
      onLoading?.(false, 0, filePaths.length);
      reject(error);
      worker.terminate();
    };

    //console.log('Posting message to worker with filePaths:', filePaths);
    try {
      worker.postMessage({ filePaths });
    } catch (postError) {
      console.error('Failed to post message to worker:', postError);
      onLoading?.(false, 0, filePaths.length);
      reject(postError);
      worker.terminate();
    }
  });
}